module.exports = __webpack_public_path__ + "img/20210708161125.c1cd1e4b.png";